// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"ff3d5715","793":"9c1ecf3a","886":"347f5755"}[chunkId] + ".css";
};